<template>
    <div class="orderListWrap">
        <!-- <nav-bar></nav-bar> -->
        <div>
            <div v-if="orderStatus != 'pending'" class="topNav fr ac jsb">
                <span class="menuItem" @click="switchNav('M')">电影</span>
                <span class="menuItem">演出</span>
                <span class="menuItem" @click="switchNav('G')">电子码</span>
                <span class="menuItem">商城</span>
            </div>
            <!-- 待支付订单 -->
            <div v-if="orderStatus == 'pending' && pendingOrder.tradeno" class="orderItems fc">
                <div class="itemWrap">
                    <div class="orderItem fc">
                        <div
                            v-show="pendingOrder.ordertype == 'S' || pendingOrder.ordertype == 'G'"
                            class="hearder fr ac jsb"
                        >
                            <span>订单编号：{{pendingOrder.tradeno}}</span>
                            <span
                                class="tc"
                            >{{pendingOrder.orderstatus == "N" && "待支付" || pendingOrder.orderstatus == "S" && "订单完成"}}</span>
                        </div>
                        <div v-show="pendingOrder.ordertype == 'G'" class="voucher_info fr ac">
                            <img class="voucher_img" :src="imgBaseUrl + pendingOrder.logo" alt />
                            <div class="voucher_detail fc jsb">
                                <h3>{{pendingOrder.ordertitle}}</h3>
                                <span>有效期：{{pendingOrder.expirydate}}</span>
                                <span>数量：{{pendingOrder.quantity}}</span>
                            </div>
                        </div>
                        <div v-show="pendingOrder.ordertype == 'S'" class="products fc">
                            <div
                                v-for="(item, index) in pendingOrder.buyItemList"
                                :key="index"
                                class="basicInfo fr"
                            >
                                <img :src="item.logo" alt />
                                <div class="info fc jsa">
                                    <h3>{{item.productName}}555</h3>
                                    <span class="sku grey">{{item.skuName}}</span>
                                    <div class="fr ac jsb">
                                        <span class="grey">
                                            <strong class="price">{{item.price}}元</strong>
                                        </span>
                                        <span class="grey">×{{item.qty}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="pendingOrder.ordertype == 'M'" class="productInfo fr">
                            <img :src="pendingOrder.logo" />
                            <div class="basicInfo fc">
                                <h3>{{pendingOrder.name}}</h3>
                                <span class="grey">{{pendingOrder.screening}}</span>
                                <span class="grey">{{pendingOrder.cinema}}</span>
                                <span class="grey">{{pendingOrder.seat}}</span>
                            </div>
                        </div>
                        <div class="price row fr ac">
                            订单金额：
                            <strong class="tc">{{pendingOrder.amount}}</strong>
                        </div>
                        <div class="operates row fr ac jsb">
                            <span
                                v-if="pendingOrder.ordertype == 'M' || pendingOrder.ordertype == 'G'"
                                class="tc"
                            >剩余支付时间：{{Math.floor(remainingTime / 60)}}:{{remainingTime % 60 &lt; 10 ? '0'+remainingTime % 60 : remainingTime % 60}}</span>
                            <span v-else></span>
                            <div class="btns fr ac">
                                <button @click="cancleOrder" class="cancle">取消</button>
                                <button
                                    @click="payOrder(pendingOrder.tradeno, pendingOrder.seat)"
                                    class="pay bg_tc"
                                >付款</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 已支付订单 -->
            <div v-if="orderStatus == 'paid' && paidOrderList.length" class="orderItems fc">
                <div
                    class="itemWrap"
                    @click="viewOrder(item.tradeno)"
                    v-for="item in paidOrderList"
                    :key="item.tradeno"
                    data-type="0"
                >
                    <!-- <div
                        class="orderItem fc"
                        @touchstart.capture="touchStart"
                        @touchend.capture="touchEnd"
                    >-->
                    <div class="orderItem fc">
                        <div class="productInfo fr">
                            <img :src="item.logo" />
                            <div class="basicInfo fc">
                                <h3>{{item.name}}</h3>
                                <span class="grey">{{item.screening}}</span>
                                <span class="grey">{{item.cinema}}</span>
                                <span class="grey">{{item.seat}}</span>
                            </div>
                        </div>
                        <div class="price row fr ac jsb">
                            <span>
                                订单金额：
                                <strong class="tc">{{item.amount}}</strong>
                            </span>
                            <span
                                class="tc"
                            >{{item.orderstatus == 'R' && '退款' || item.orderstatus == 'S' && '出票成功' || item.orderstatus == 'F' && '出票失败' || item.orderstatus == 'P' && '支付完成等待出票' || item.orderstatus == 'WR' && '退款'}}</span>
                        </div>
                    </div>
                    <!-- <div @click.stop="delOrder(item.tradeno)" class="deleteBtn center">删除</div> -->
                </div>
            </div>
            <!-- 暂无订单 -->
            <p v-if="!pendingOrder.tradeno && !paidOrderList.length" class="noOrder grey">您暂时还没有订单哦</p>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast, MessageBox } from "mint-ui";
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            orderStatus: this.$route.query.orderStatus,
            pendingOrder: {}, //待支付订单
            remainingTime: 0, //支付剩余时间
            interval: null,
            paidOrderList: [], //已支付订单
            startX: 0,
            endX: 0,
            seatsArr: [],
            orderType: "M",
            page_no: 0,
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "", //获取微信openid需要的code
        };
    },
    watch: {
        orderType(val, oldVal) {
            this.paidOrderList = [];
            this.page_no = 0;
            this.getPaidOrder();
        },
    },
    components: {
        navBar,
    },
    created() {
        console.log(this.orderStatus);
        switch (this.orderStatus) {
            case "pending":
                this.getPendingOrder();
                break;
            case "paid":
                this.getPaidOrder();
                break;
        }
        if (this.code && !this.openid) {
            this.getOpenId();
        }
    },
    methods: {
        viewOrder(tradeno) {
            this.$router.push({
                path: "/orderDetail",
                query: { tradeno: tradeno },
            });
        },
        switchNav(type) {
            this.orderType = type;
        },
        delOrder(tradeno) {
            MessageBox.confirm("确定删除此订单?")
                .then((action) => {
                    if (action == "confirm") {
                        this.confirmDelOrder(tradeno);
                    }
                })
                .catch((err) => {
                    this.restSlide();
                });
        },
        confirmDelOrder(tradeno) {
            this.$post({
                method: "member.order.del",
                tradeno: tradeno,
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.getPaidOrder();
                    this.restSlide();
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                    this.restSlide();
                }
            });
        },
        //滑动开始
        touchStart(e) {
            // 记录初始位置
            this.startX = e.touches[0].clientX;
        },
        //滑动结束
        touchEnd(e) {
            // 当前滑动的父级元素
            let parentElement = e.currentTarget.parentElement;
            // 记录结束位置
            this.endX = e.changedTouches[0].clientX;
            // 左滑
            if (
                parentElement.dataset.type == 0 &&
                this.startX - this.endX > 30
            ) {
                this.restSlide();
                parentElement.dataset.type = 1;
            }
            // 右滑
            if (
                parentElement.dataset.type == 1 &&
                this.startX - this.endX < -30
            ) {
                this.restSlide();
                parentElement.dataset.type = 0;
            }
            this.startX = 0;
            this.endX = 0;
        },
        //复位滑动状态
        restSlide() {
            let listItems = document.querySelectorAll(".itemWrap");
            // 复位
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].dataset.type = 0;
            }
        },
        //  获取待支付订单
        getPendingOrder() {
            this.$post({
                method: "member.order.unpaid.get",
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.pendingOrder = res.data.order;
                    if (JSON.stringify(res.data.order) != "{}") {
                        this.getRemainingTime();
                        this.seatsArr = res.data.order.seat
                            ? res.data.order.seat.split(",")
                            : [];
                    }
                }
            });
        },
        //  获取订单支付剩余时间
        getRemainingTime() {
            this.$post({
                method: "member.order.remaining",
                auth_code: this.getLocal("auth_code"),
                tradeno: this.pendingOrder.tradeno,
            }).then((res) => {
                if (res.success) {
                    this.remainingTime = res.data.remaining;
                    this.countDown();
                }
            });
        },
        //  倒计时
        countDown() {
            this.interval = null;
            this.interval = setInterval(() => {
                this.remainingTime--;
                if (this.remainingTime < 1) {
                    clearInterval(this.interval);
                    this.getPendingOrder();
                }
            }, 1000);
        },
        //  获取已支付订单
        getPaidOrder() {
            this.$post({
                method: "member.order.paid.list",
                auth_code: this.getLocal("auth_code"),
                ordertype: this.orderType,
                page_no: this.page_no,
            }).then((res) => {
                if (res.success) {
                    this.paidOrderList = res.data.orders;
                }
            });
        },
        //  取消订单
        cancleOrder() {
            MessageBox.confirm("确定取消此订单?")
                .then((action) => {
                    if (action == "confirm") {
                        this.confirmCancle();
                    }
                })
                .catch((err) => {});
        },
        confirmCancle() {
            this.$post({
                method: "member.order.cancel",
                auth_code: this.getLocal("auth_code"),
                tradeno: this.pendingOrder.tradeno,
            }).then((res) => {
                if (res.success) {
                    this.getPendingOrder();
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code,
            }).then((res) => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        //  去付款
        payOrder(tradeno, seat) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=movie"
                );
                window.location.href = url;
                return;
            }
            this.$router.push({
                path: "/confirmOrder",
                query: {
                    tradeno: tradeno,
                    seatsTxt: seat,
                    posterUrl: this.pendingOrder.logo,
                    ticketNum: this.seatsArr.length,
                },
            });
        },
    },
};
</script>
<style lang="scss">
.orderListWrap {
    .topNav {
        width: 100%;
        height: 100px;
        padding: 0;
        background: #fff;
        .menuItem {
            width: 186px;
            text-align: center;
            font-size: 30px;
            height: 50px;
            line-height: 50px;
            border-right: 1px solid #eee;
        }
        .menuItem:last-of-type {
            border-right: none;
        }
        .active {
            color: #e42f46;
        }
    }
    .orderItems {
        overflow: hidden;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        .itemWrap {
            position: relative;
            -webkit-transition: all 0.2s;
            transition: all 0.2s;
            .orderItem {
                width: 100%;
                margin: 20px 0;
                background-color: #fff;
                border-radius: 15px;
                box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.08);
                .hearder {
                    height: 80px;
                    width: 100%;
                    padding: 0 30px;
                    box-sizing: border-box;
                    font-size: 28px;
                    border-bottom: 1px solid #eee;
                }
                .voucher_info {
                    width: 100%;
                    padding: 0 30px;
                    box-sizing: border-box;
                    height: 160px;
                    .voucher_img {
                        width: 120px;
                        height: 120px;
                        margin-right: 20px;
                    }
                    .voucher_detail {
                        width: calc(100% - 140px);
                        height: 120px;
                        h3 {
                            font-size: 28px;
                        }
                        span {
                            font-size: 24px;
                            color: #999;
                        }
                    }
                }
                .products {
                    padding: 20px 30px;
                    box-sizing: border-box;
                    background: #fff;
                    .basicInfo {
                        width: 100%;
                        font-size: 28px;
                        img {
                            width: 200px;
                            height: 200px;
                        }
                        .info {
                            margin-left: 20px;
                            width: calc(100% - 220px);
                            h3 {
                                font-weight: bold;
                                line-height: 36px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                            .price {
                                // font-size: 36px;
                                color: #fe5200;
                            }
                        }
                    }
                }
                .productInfo {
                    padding: 30px;
                    box-sizing: border-box;
                    img {
                        width: 170px;
                        height: 225px;
                    }
                    .basicInfo {
                        width: calc(100% - 170px);
                        padding-left: 30px;
                        box-sizing: border-box;
                        h3 {
                            font-size: 36px;
                            line-height: 54px;
                        }
                        span {
                            font-size: 24px;
                            line-height: 40px;
                        }
                    }
                }
                .price {
                    strong {
                        font-size: 32px;
                    }
                }
                .row {
                    height: 86px;
                    border-top: 1px solid #eee;
                    padding: 0 30px;
                    box-sizing: border-box;
                    font-size: 28px;
                    .btns {
                        button {
                            width: 140px;
                            height: 60px;
                            border-radius: 10px;
                            margin-left: 20px;
                        }
                        .cancle {
                            color: #555;
                        }
                        .pay {
                            color: #fff;
                        }
                    }
                }
            }
            // .orderItem:before,
            // .orderItem:after {
            //     content: "";
            //     width: 30px;
            //     height: 30px;
            //     background-color: #f2f2f2;
            //     position: absolute;
            //     top: 250px;
            //     border-radius: 50%;
            // }
            .orderItem:before {
                left: -12px;
                top: 180px;
            }
            .orderItem:after {
                right: -12px;
                top: 180px;
            }
            .deleteBtn {
                width: 120px;
                position: absolute;
                right: -120px;
                top: 0;
                background: #ed726e;
                height: calc(100% - 40px);
                margin: 20px 0;
                font-size: 32px;
                color: #fff;
            }
        }
        .itemWrap[data-type="0"] {
            transform: translate3d(0, 0, 0);
        }
        .itemWrap[data-type="1"] {
            transform: translate3d(-120px, 0, 0);
        }
        // .itemWrap :after {
        //     content: " ";
        //     position: absolute;
        //     left: 12px;
        //     bottom: 0;
        //     right: 0;
        //     height: 1px;
        //     border-bottom: 1px solid #ccc;
        //     color: #ccc;
        //     -webkit-transform-origin: 0 100%;
        //     transform-origin: 0 100%;
        //     -webkit-transform: scaleY(0.5);
        //     transform: scaleY(0.5);
        //     z-index: 2;
        // }
    }
    .noOrder {
        width: 100%;
        text-align: center;
        font-size: 28px;
        margin-top: 250px;
    }
}
.mint-msgbox {
    font-size: 28px !important;
    border-radius: 10px;
    .mint-msgbox-header {
        padding-top: 30px;
        .mint-msgbox-title {
            font-size: 30px !important;
        }
    }
    .mint-msgbox-content {
        padding: 30px;
    }
    .mint-msgbox-btns {
        height: 70px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/orderList.vue